import * as dom from 'monaco-editor/esm/vs/base/browser/dom.js';
import { CellContentPart } from '../cellPart.js';
class CellFocusPart extends CellContentPart {
    constructor(containerElement, focusSinkElement, notebookEditor) {
        super();
        this._register(dom.addDisposableListener(containerElement, dom.EventType.FOCUS, () => {
            if (this.currentCell) {
                notebookEditor.focusElement(this.currentCell);
            }
        }, true));
        if (focusSinkElement) {
            this._register(dom.addDisposableListener(focusSinkElement, dom.EventType.FOCUS, () => {
                if (this.currentCell && this.currentCell.outputsViewModels.length) {
                    notebookEditor.focusNotebookCell(this.currentCell, 'output');
                }
            }));
        }
    }
}
export { CellFocusPart };
